import React, { Component } from 'react'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { UploadCSVBackups } from './'
import { db } from '../../config/firebaseconfig'
import parseSnapshot from '../../helpers/parseSnapshot'
import unwindBackup from '../../helpers/assessment/unwindBackup'
import restoreBackup from '../../helpers/assessment/uploadCSV/restoreBackup';

/**
 * Manages state and logic for UploadCSVBackups, 
 * on /assessment/upload/backups/ route, which
 * allows user to see bulk uploads and reverse them
 * or (if reversed) re-run them.
 */
class UploadCSVBackupsContainer extends Component {
  state = {
    assessmentName: '',
    backupRestoring: '',
    error: false,
    loading: false,
    loadingComplete: false,
    processedStudents: 0,
    restoreError: false,
    restoreStatus: '',
    schoolName: '',
    status: '',
    statusClasses: 0,
    statusGroupUAs: 0,
    statusStudents: 0,
    statusTeachers: 0,
    statusUserAssessments: 0,
    totalStudents: 0,
    unwindErrors: [],
    unwindPhase: '',
    backupUnwinding: '',
    district: '',
  }

  componentDidMount() {
    const {recordId, assessmentId, year} = this.parseRoute()

    this.setState({loading: true})

    // Fetch all of the relevant backups for the year, school,
    // and assessment specified in the route
    const fetchBackups = db.collection('legacyUploadBackups')
      .where('recordId', '==', recordId)
      .where('schoolYear', '==', year)
      .where('assessmentId', '==', assessmentId)
      .get()
      .then(results => {
        this.backups = parseSnapshot(results)
      })

    // Fetch the school's name and the district id
    const fetchSchoolName = db.collection('schools').doc(recordId).get()
      .then(doc => {
        if (doc.exists) {
          const data = doc.data()
          this.setState({
            schoolName: data.name, 
            district: data.district, 
            school: data,
          })
        }
      })

    // Fetch the assessment's name.
    const fetchAssessmentName = db.collection('sets').doc(assessmentId).get()
      .then(doc => {
        if (doc.exists) {
          this.setState({assessmentName: doc.data().displayName})
        }
      })
    
    Promise.all([fetchBackups, fetchSchoolName, fetchAssessmentName])
      .then(() => {
        this.setState({ loading: false, loadingComplete: true })
      })
      .catch(err => {
        console.log(err)
        this.setState({loading: false, error: true})
      })
  }

  // Utility function to get info from the route.
  parseRoute = () => {
    const { recordId, recordType } = this.props.match.params
    const { search, pathname } = this.props.location
    const { a: assessmentId, sy: year } = queryString.parse(search)
    return {recordId, recordType, assessmentId, pathname, year, search}
  }

  // Generate link to go back to main upload CSV page
  linkToUpload = () => {
    const { recordId, recordType, search } = this.parseRoute()
    const BASE_LINK = '/assessment/upload/'
    const ROUTE = `${recordType}/${recordId}`
    return `${BASE_LINK}${ROUTE}${search}`
  }

  // Function for unwinding (deleting) the data generated
  // from an upload.
  unwind = (backup) => {
    const { district } = this.state
    unwindBackup(backup, this.setState.bind(this), district)
  }

  restore = (backup) => {
    const { school } = this.state
    if (!school) return
    restoreBackup(backup, school, this.setState.bind(this))
  }
  
  render() {
    const { 
      assessmentName,
      backupRestoring,
      backupUnwinding,
      error,
      loading,
      loadingComplete,
      processedStudents,
      restoreError,
      restoreStatus,
      schoolName,
      status,
      statusClasses,
      statusGroupUAs,
      statusStudents,
      statusTeachers,
      statusUserAssessments,
      totalStudents,
      unwindErrors,
      unwindPhase,
    } = this.state
    const { 
      backups, 
      linkToUpload, 
      parseRoute, 
      restore,
      unwind, 
    } = this
    const { year } = parseRoute()
    
    return (
      <UploadCSVBackups 
        assessmentName={assessmentName}
        backups={backups} 
        backupRestoring={backupRestoring}
        backupUnwinding={backupUnwinding}
        error={error}
        linkToUpload={linkToUpload()}
        loading={loading}
        loadingComplete={loadingComplete}
        processedStudents={processedStudents}
        restore={restore}
        restoreError={restoreError}
        restoreStatus={restoreStatus}
        schoolName={schoolName}
        status={status}
        statusClasses={statusClasses}
        statusGroupUAs={statusGroupUAs}
        statusStudents={statusStudents}
        statusTeachers={statusTeachers}
        statusUserAssessments={statusUserAssessments}
        totalStudents={totalStudents}
        unwind={unwind}
        unwindErrors={unwindErrors}
        unwindPhase={unwindPhase}
        year={year}
      />
    )
  }
}

const { object } = PropTypes
UploadCSVBackupsContainer.propTypes = {
  location: object.isRequired,
  match: object.isRequired,
}
export default UploadCSVBackupsContainer


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVBackupsContainer.js